import { toObject } from '../DefaultPanel/utils/petri';
var experimentChangeHandler = Symbol.for('debug-panel:experiment-changed-handlers');
function getHandlers() {
    if (!window[experimentChangeHandler]) {
        window[experimentChangeHandler] = [];
    }
    return window[experimentChangeHandler];
}
export function onExperimentsChange(func) {
    getHandlers().push(func);
    return function () {
        var index = getHandlers().indexOf(func);
        if (index !== -1) {
            getHandlers().splice(index, 1);
        }
    };
}
export function experimentHasChanged(experiments) {
    var experimentsBag = toObject(experiments);
    getHandlers().forEach(function (handler) {
        handler(experimentsBag);
    });
}
//# sourceMappingURL=onExperimentsChange.js.map